"use strict";

var _span;
import "core-js/modules/es.symbol.description.js";
import { CDN } from '@autoguru/global-configs';
import { Box, Column, Columns, Heading, Stack, Text, useTextStyles } from '@autoguru/overdrive';
import { NextPicture, Picture } from '@autoguru/picture';
import * as styles from '~/src/components/KiaOraIntro/KiaOraIntro.css';
import { contentIntro } from '~/src/components/KiaOraIntro/contentIntro';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ScrollToForm = () => {
  const scrollDiv = document.getElementById('learn-more').offsetTop;
  window.scrollTo({
    top: scrollDiv,
    behavior: 'smooth'
  });
  return null;
};
export const KiaOraIntroDesktop = () => /*#__PURE__*/_jsx(Box, {
  paddingTop: "8",
  paddingBottom: "4",
  style: {
    maxWidth: '1600px',
    margin: '0 auto'
  },
  children: /*#__PURE__*/_jsxs(Columns, {
    children: [/*#__PURE__*/_jsx(Column, {
      width: "2/5",
      paddingRight: "6",
      alignItems: "center",
      justifyContent: "center",
      className: styles.contentLeft,
      children: /*#__PURE__*/_jsxs(Stack, {
        space: "6",
        children: [/*#__PURE__*/_jsxs(Heading, {
          as: "h1",
          size: "9",
          className: styles.title,
          children: [contentIntro.title, _span || (_span = /*#__PURE__*/_jsx("span", {
            children: " "
          })), /*#__PURE__*/_jsx(Box, {
            display: "inlineBlock",
            children: /*#__PURE__*/_jsxs(Box, {
              display: "flex",
              flexDirection: "column",
              children: [/*#__PURE__*/_jsx(Text, {
                strong: true,
                colour: "success",
                size: "9",
                className: styles.title,
                children: "faster"
              }), /*#__PURE__*/_jsx(Box, {
                width: "full",
                paddingTop: "2",
                children: /*#__PURE__*/_jsx(Picture, {
                  backgroundColor: "transparent",
                  altText: "arc",
                  sizes: "40px",
                  width: 40,
                  height: "auto",
                  aspectRatio: 75 / 25,
                  src: `${CDN}/images/nz/landing/otto-smile.svg`
                })
              })]
            })
          })]
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          size: "5",
          children: contentIntro.description
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          size: "5",
          children: contentIntro.subText
        }), /*#__PURE__*/_jsxs(Box, {
          children: [/*#__PURE__*/_jsx(Box, {
            as: "a",
            href: "/login",
            rel: "noopener noreferrer nofollow",
            marginTop: "1",
            paddingX: "4",
            paddingY: "3",
            marginRight: "4",
            backgroundColour: "white",
            borderColour: "dark",
            borderRadius: "1",
            display: "inlineBlock",
            borderWidth: "1",
            className: useTextStyles({
              colour: 'dark',
              weight: 'bold'
            }),
            children: contentIntro.btnLogin
          }), /*#__PURE__*/_jsx(Box, {
            as: "button",
            marginTop: "1",
            paddingX: "4",
            paddingY: "3",
            backgroundColour: "green500",
            borderRadius: "1",
            borderWidth: "1",
            display: "inlineBlock",
            className: [styles.btnLearnMore, useTextStyles({
              colour: 'dark',
              weight: 'bold'
            })],
            onClick: ScrollToForm,
            children: contentIntro.btnLearnMore
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(Column, {
      width: "3/5",
      alignItems: "center",
      paddingLeft: "8",
      className: styles.contentRight,
      children: /*#__PURE__*/_jsx(NextPicture, {
        className: styles.imgHero,
        backgroundColor: "transparent",
        altText: contentIntro.altImgFeaturedText,
        quality: 90,
        sizes: "1200px",
        aspectRatio: contentIntro.desktopAspectRatioImgFeatured,
        objectFit: "cover",
        src: `${CDN}/images/nz/landing/${contentIntro.desktopImgFeaturedPath}`
      })
    })]
  })
});